export default {
	// Backend Types
	LINED_UP: '1',
	TWO_COLUMNS: '2',
	THREE_COLUMNS: '3',
	FOUR_COLUMNS: '4',
	FIVE_COLUMNS: '5',
	GROUPS: '6',

	// Frontend Types
	DROPDOWN_WITH_CHILDS: '50',
	DROPDOWN_WITHOUT_CHILDS: '51',
	BUTTON: '52',
	LOADING: '99',
}
